import * as React from "react";
import { useTranslation } from "react-i18next";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { Button, MenuItem } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { INTERNAL_DATA_LAKE_TYPE } from "data-lake/Constants";
import { INTERNAL_DATA_LAKE_STORAGE_TYPE } from "data-lake/preview/storage-types/internal/Constants";
const RetrievalArchiveButton = ({
  onClick,
  buttonType = "menu",
  dataLakeType = INTERNAL_DATA_LAKE_TYPE,
  dataLakeStorageType = INTERNAL_DATA_LAKE_STORAGE_TYPE,
  disabled = false,
  title = void 0
}) => {
  const { t } = useTranslation("enterprise_data_lake");
  const sendTelemetry = useSendTelemetry();
  const onRetrieval = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE[dataLakeType].DATA_RETRIEVAL_OPENED, {
      event_details: {
        data_lake_storage_type: dataLakeStorageType
      }
    });
    onClick();
  };
  const isMenuButton = buttonType === "menu";
  const ItemComponent = isMenuButton ? MenuItem : Button;
  return /* @__PURE__ */ React.createElement(ItemComponent, { onClick: onRetrieval, bsSize: "xsmall", disabled, title }, t("retrieval_archive_button.label"));
};
export default RetrievalArchiveButton;
